import { combineKeys, queryKey } from '../../../../utils/queryUtils';

export const bookmarksKey = queryKey('bookmarks');
const continueWatchingKey = queryKey('continue-watching');
export const continueWatchingTitlesKey = combineKeys(() => [bookmarksKey(), continueWatchingKey()]);
